import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch, faSpinnerThird} from "@fortawesome/pro-regular-svg-icons";

type ListSearchProps = {
    handleSearchTermChange: ((searchTerm: string) => void)
    placeholder: string
    value?: string
    initialValue?: string
    isLoading?: boolean
}

const ListSearch: React.FC<ListSearchProps> = ({handleSearchTermChange, placeholder, value, initialValue = '', isLoading = false}) => {
    // If value is provided, use controlled mode. Otherwise use internal state with initialValue
    const [internalValue, setInternalValue] = React.useState(initialValue);
    const isControlled = value !== undefined;
    const actualValue = isControlled ? value : internalValue;

    // Update internal value when initialValue changes (for uncontrolled mode)
    React.useEffect(() => {
        if (!isControlled) {
            setInternalValue(initialValue);
        }
    }, [initialValue, isControlled]);

    const handleInputChange = (newValue: string) => {
        if (!isControlled) {
            setInternalValue(newValue);
        }
        handleSearchTermChange(newValue);
    };

    return (
        <form className="mt-6 flex space-x-4" action="#">
            <div className="flex-1 min-w-0">
                <label htmlFor="search" className="sr-only">Search</label>
                <div className="relative rounded-md shadow-xs">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faSearch} className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                    </div>
                    <input 
                        autoFocus={true} 
                        type="search"
                        value={actualValue}
                        className="focus:ring-red-500 focus:border-red-500 block w-full pl-10 pr-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder={placeholder} 
                        onChange={e => handleInputChange(e.target.value)}
                    />
                    {isLoading && (
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <FontAwesomeIcon icon={faSpinnerThird} spin className="h-4 w-4 text-gray-400" aria-hidden="true"/>
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
}

export default ListSearch;
